import { EPluggyTypes } from "@/core/@types/types";
import PluggyConnectorInit from "@/core/common/Pluggy/services/PluggyConnectorInit";
import handleCriarWebservice from "@/core/common/Pluggy/handlers/handleCriarWebservice";
import { IHandleWebservice } from "@/core/common/Pluggy/handlers/handleCriarWebservice";
import PluggyGatewayAdapter from "@/core/common/Pluggy/services/adaptors/PluggyGatewayAdapter";
import WebserviceGatewayAdapter from "@/core/common/Pluggy/services/adaptors/WebserviceGatewayAdapter";
import { PluggyGateway } from "@/core/common/Pluggy/services/ports/PluggyGateway";
import { WebserviceGateway } from "@/core/common/Pluggy/services/ports/WebserviceGateway";
import { IPluggyConnector } from "@/core/common/Pluggy/services/types";
import { ContainerModule } from "inversify";

const pluggyContainer = new ContainerModule((bind) => {
  bind<IPluggyConnector>(EPluggyTypes.PLUGGY_CONNECTOR).to(PluggyConnectorInit);
  bind<PluggyGateway>(EPluggyTypes.PLUGGY_GATEWAY).to(PluggyGatewayAdapter);
  bind<WebserviceGateway>(EPluggyTypes.CRIAR_WEBSERVICE).to(
    WebserviceGatewayAdapter
  );
  bind<IHandleWebservice>(EPluggyTypes.HANDLE_WEBSERVICE).to(
    handleCriarWebservice
  );
});

export { pluggyContainer };
